import { Text } from '@mantine/core';
import { getDocumentTypeLabel } from 'src/data-capture/utils/documentCategory';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatDateTimeWithComma } from 'src/meetings/utils/date-utils';
import { UploadedFile } from '../../hooks/file-uploads/types';
import { FilesTableColumn } from './FilesTable';

export const filedDocumentColumns: FilesTableColumn<UploadedFile>[] = [
  {
    label: 'Created',
    sortable: true,
    // Folders show an em dash, so sort them as null (last) rather than by an invisible date
    sortValueGetter: (record: UploadedFile) => (record.isFolder ? null : record.createdAt),
    valueBuilder: (record: UploadedFile) => (
      <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.10" lh="18px">
        {record.isFolder ? '—' : formatDateTimeWithComma(record.createdAt)}
      </Text>
    ),
  },
  {
    label: 'Type',
    sortable: true,
    sortValueGetter: (record: UploadedFile) => getDocumentTypeLabel(record),
    valueBuilder: (record: UploadedFile) => (
      <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.10" lh="18px">
        {getDocumentTypeLabel(record)}
      </Text>
    ),
  },
];
